import React, { Fragment } from 'react';
import { Modal, Radio, Checkbox } from 'antd';
import $ST from 'plugins/tfs/platformConfigs/staticTextMaps/packageOrderList';
import Barcode from 'react-barcode';
import Button from 'components/ui-ant/Button';
import { thumbnailImageUrl } from 'theme/utils';

// pageContainer
import PrintButton from '_pageContainers/oms/TransferOrderList/printableView';

export const PrintButtonGrid = (pageContext) => {
  const {
    componentRef,
    loading,
    modalReady,
    data,
    isCheckboxDisabled,
    isPrintable,
    handlePrint,
    handleCheckboxChange,
    loadData,
    extractAttributes,
    setModalReady,
    setLoading,
    setUncheckedList,
  } = pageContext;

  const buttonText = loading
    ? $ST.PRINT_MODAL.PLEASE_WAIT
    : $ST.PRINT_MODAL.PRINT;

  const SingleProductView = ({ data }) => {
    const { colorCode, barcode, size } = extractAttributes(data.product);

    const barcodeVal = barcode.split(',')[0];
    const [productImage] = data.product.productimage_set;

    return (
      <div key={data.id} className='printable-list__single-item'>
        <div className='order-number'>
          <Barcode value={data.order_number} height={55} />
        </div>
        <div className='product-info'>
          <div className='product-name'>{data.product.name}</div>
          <div>{data.number}</div>
          <div>
            {$ST.PRINT_MODAL.COLOR}: {colorCode}-{$ST.PRINT_MODAL.SIZE} : {size}
          </div>
        </div>
        {productImage && (
          <div className='product-photo'>
            <img src={thumbnailImageUrl(productImage.url, 70, 70)} alt='' />
          </div>
        )}
        <div className='barcode-number'>
          <Barcode value={barcodeVal} height={55} />
        </div>
      </div>
    );
  };

  const GroupByProductView = ({ data, onChange, isPrintable, isDisabled }) => {
    return data.map((packageItem) => {
      const { order_number, number, transferitem_set } = packageItem;
      const printable = isPrintable(number);
      if (!transferitem_set.length) return null;
      return (
        <div
          key={number}
          className={`printable-list__wrapper ${printable ? '' : 'noprint'}`}
        >
          <div className='printable-list__group_name'>
            <Checkbox
              disabled={isDisabled}
              className='noprint'
              defaultChecked={true}
              checked={printable}
              onChange={(e) => onChange(e, number)}
            />
            {$ST.PRINT_MODAL.PACKAGE_NUMBER}: {number}
          </div>
          {packageItem.transferitem_set.map((item) => {
            return (
              <SingleProductView
                key={item.id + number}
                data={{ ...item, order_number, number }}
              />
            );
          })}
        </div>
      );
    });
  };

  return (
    <Fragment>
      <Modal
        title={$ST.PRINT_MODAL.PRINT_PREVIEW}
        width='75%'
        visible={modalReady}
        onOk={() => {
          handlePrint();
        }}
        okText={$ST.PRINT_MODAL.PRINT}
        onCancel={() => {
          setModalReady(false);
          setLoading(false);
          setUncheckedList([]);
        }}
      >
        <Radio.Group value='product' buttonStyle='solid'>
          <Radio.Button value='product'>
            {$ST.PRINT_MODAL.GROUP_BY_PRODUCT}
          </Radio.Button>
        </Radio.Group>

        <div ref={componentRef !== undefined && componentRef}>
          <GroupByProductView
            data={data}
            onChange={handleCheckboxChange}
            isPrintable={isPrintable}
            isDisabled={isCheckboxDisabled}
          />
        </div>
      </Modal>
      <Button
        type='primary'
        loading={loading}
        onClick={loadData}
        disabled={false}
        className='listing-print-button'
      >
        {buttonText}
      </Button>
    </Fragment>
  );
};

export default PrintButton(PrintButtonGrid);



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/oms/TransferOrderList/printableView/index.js